module.exports = __webpack_public_path__ + "static/app-store_badge--white-94501d9274b2bde9f7f4dea1095d883f.svg";